import React, {useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {signIn} from "../rest/clientV2";
import {useHistory} from "react-router-dom";
import {useSetRecoilState} from "recoil";
import {userState} from "../state/userState";
import * as O from 'fp-ts/Option';
import {User} from "../domain/User";


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignIn() {
  const classes = useStyles();

  const history = useHistory();
  const setUser = useSetRecoilState(userState)
  const [email, setEmail] = useState('');
  const [pws, setPws] = useState('');
  const [errorMessage, setErrormMessage] = useState('')

  const onSignIn = async () => {
    try {
      setErrormMessage('')
      const userTO = await signIn(email, pws)
      console.log("OK")
      console.log(userTO)
      const user ={
        id: userTO.id,
        email: userTO.email
      } as User;
      setUser(O.some(user));
      history.push("/sentiment/en");
    } catch (e) {
      console.log("ERROR")
      console.log(e)
      setErrormMessage(e)
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline/>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon/>
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={pws}
            onChange={e => setPws(e.target.value)}
          />
          {/*<FormControlLabel*/}
          {/*    control={<Checkbox value="remember" color="primary" />}*/}
          {/*    label="Remember me"*/}
          {/*/>*/}
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={onSignIn}
          >
            Sign In
          </Button>
          {/*<Grid container>*/}
          {/*    <Grid item xs>*/}
          {/*        <Link href="#" variant="body2">*/}
          {/*            Forgot password?*/}
          {/*        </Link>*/}
          {/*    </Grid>*/}
          {/*    <Grid item>*/}
          {/*        <Link href="#" variant="body2">*/}
          {/*            {"Don't have an account? Sign Up"}*/}
          {/*        </Link>*/}
          {/*    </Grid>*/}
          {/*</Grid>*/}
        </form>
      </div>
      <Box mt={4}>
        <Typography variant="body2" style={{color: 'rgb(250,0, 87)'}} align="center">
          {errorMessage}
        </Typography>
      </Box>
    </Container>
  );
}

